import { useState } from 'react'
import {
  Space,
  Typography,
  Row,
  Col,
  Form,
  notification,
  Select,
  Input,
  Input as InputAntd,
} from 'antd'
import _ from 'lodash'
import { useAsync } from 'react-use'

import Page from 'components/Page'
import Button from 'components/Button'
// import SearchOrganization from 'components/SearchOrganization'
import ReportIncidents from 'components/ReportIncidents'

import { useTranslate } from 'hooks/translate'
import { useParams } from 'react-router-dom'
// import moment from 'utils/moment'
import { useHistory } from 'react-router-dom'

import {
  getMyIncidentListApi,
  getReportTypeListApi,
  getMyIncidentApi,
  getReportStatusListApi,
  getOptionsBusinessProcessApi,
  getUserListApi,
  getUserFilterList,
  getRiskOwnerOrgFilterList,
} from 'services/myIncident'
import DatePicker from 'components/DatePicker'

// import { convertOrganizationalStructureToFilters } from 'utils/organization'
import { ScheduleOutlined } from '@ant-design/icons'
import Styled from './styled'
import { UpOutlined, DownOutlined } from '@ant-design/icons'
import { getOrganizationListApi } from 'services/organization'

const DEFAULT_PAGE_SIZE = 10

export default function MyIncident () {
  const { t } = useTranslate()
  const { id, hederId } = useParams()
  // const { employee, profile, user_id } = JSON.parse(localStorage.user)
  const history = useHistory()
  const [oldDataSource, setOldDataSource] = useState([])
  const [currentDataSource, setCurrentDataSource] = useState([])
  const [selectedRowKeys, setSelectedRowKeys] = useState([])
  const [loading, setLoading] = useState(false)
  const [filters, setFilters] = useState({
    profile_id: null,
    role_id: null,
    employee_name: null,
    page: 1,
    size: DEFAULT_PAGE_SIZE,
  })
  const [assigneeOptions, setAssigneeOptions] = useState([])

  const [reportTypeList, setReportTypeList] = useState([])
  const [reportTypeData, setReportTypeData] = useState(null)
  const [reportTypeId, setReportTypeId] = useState(null)
  const [reportStatusList, setReportStatusList] = useState([])
  const [RiskOwnerOrgList, setRiskOwnerOrgList] = useState([])
  const [UserList, setUserList] = useState([])
  const [BUList, setBUList] = useState([])
  const [reportStatusData, setReportStatusData] = useState(null)
  const [reportStatusId, setReportStatusId] = useState(1)
  const [reportData, setReportData] = useState(null)
  const [action, setAction] = useState('save')
  const [riskCo, setRiskCo] = useState(null)
  const [riskChecker, setRiskChecker] = useState(null)
  const [riskCoList, setRiskCoList] = useState([])
  const [showHeader, setShowHeader] = useState(true)
  const [canEdit, SetCanEdit] = useState(true)
  const [canEditButtonGroup, SetCanEditButtonGroup] = useState(true)
  const [canSelectAssignee, SetCanSelectAssignee] = useState(true)
  const org = JSON.parse(localStorage.getItem('org'))
  const isCentralReporter =
    JSON.parse(localStorage.getItem('user'))?.profile?.role?.role_name === 'Central Reporter'
  const isRiskAnalyst =
    JSON.parse(localStorage.getItem('user'))?.profile?.role?.role_name === 'Risk Analyst'
  const isRiskCo = ['Risk Coordinator', 'Executive Risk Coordinator'].includes(
    JSON.parse(localStorage.getItem('user'))?.profile?.role?.role_name
  )
  // console.log('-=-=-=-=-=-=-=-=-=-=-=-=', isRiskAnalyst, reportStatusId)
  const userId = JSON.parse(localStorage.getItem('user'))?.user_id || null
  const [isReportOwnself, setIsReportOwnself] = useState(false)
  const [isConfidential, setIsConfidential] = useState(false)
  const [riskOwnself, setRiskOwnself] = useState([])
  const [riskOwnerOrg, setRiskOwnerOrg] = useState(null)
  const [riskCoOrg, setRiskCoOrg] = useState(null)
  const [validAssignee, setValidAssignee] = useState(false)

  const _list = async () => {
    if (loading) return

    const params = {
      ...filters,
    }

    setLoading(true)

    const res = await getMyIncidentListApi(params)

    setLoading(false)

    if (res.status === 'error') {
      notification.error({
        message: 'Failed',
        description: res.message,
      })

      return
    }

    setOldDataSource(res.data?.items)
    setCurrentDataSource(res.data?.items)
  }

  const getReportTypeList = async () => {
    const reportListType = await getReportTypeListApi()
    const formatReportListType = _.map(reportListType?.data, (item) => {
      return { ...item, label: item.name, value: item.id }
    })
    let isReport = formatReportListType?.find((item) => {
      return +item?.report_type_id === +id
    })
    setIsReportOwnself(isReport?.is_report_ownself || false)
    setIsConfidential(isReport?.is_confidential || false)

    if (isReportOwnself && !hederId) {
      const res = await getOrganizationListApi({
        company_id: [`${org?.company_id}`],
        group_id: [`${org?.group?.group_id}`],
        bu_id: [`${org?.bu_id || 0}`],
        division_id: [`${org?.division?.division_id || 0}`],
        section_id: [`${org?.section_id || 0}`],
      })
      let riskOwn = []
      if (res?.data[0]?.id) {
        riskOwn = [`${res?.data[0]?.id}`]
      }
      if (res?.data[0]?.groups[0]?.id) {
        riskOwn = [`${res?.data[0]?.id}-${res?.data[0]?.groups[0]?.id}`]
      }
      if (res?.data[0]?.groups[0]?.bus[0]?.id) {
        riskOwn = [
          `${res?.data[0]?.id}-${res?.data[0]?.groups[0]?.id}-${res?.data[0]?.groups[0]?.bus[0]?.id}`,
        ]
      }
      if (res?.data[0]?.groups[0]?.bus[0]?.id) {
        riskOwn = [
          `${res?.data[0]?.id}-${res?.data[0]?.groups[0]?.id}-${res?.data[0]?.groups[0]?.bus[0]?.id}`,
        ]
      }

      setRiskOwnself(riskOwn)
    }
    getRiskOwnerOrgList(isReport?.is_report_ownself || false)

    setReportTypeList(formatReportListType)
  }

  // useAsync(async () => {
  //   if (isReportOwnself && !hederId && checkRiskOwner) {
  //     setCheckRiskOwner(false)
  //     const res = await getOrganizationListApi({
  //       company_id: [`${org?.company_id}`],
  //       group_id: [`${org?.group?.group_id}`],
  //       bu_id: [`${org?.bu_id || 0}`],
  //       division_id: [`${org?.division?.division_id || 0}`],
  //       section_id: [`${org?.section_id || 0}`],
  //     })
  //     // form.setFieldsValue({
  //     //   risk_owner_company_id: [
  //     //     `${org?.company_id || 0}-${org?.group?.group_id || 0}-${org?.bu_id || 0}-${org?.division
  //     //       ?.division_id || 0}-${org?.department_id || 0}-${org?.section_id || 0}`,
  //     //   ],
  //     // })
  //   }
  // }, [isReportOwnself, hederId, org])

  const getRiskOwnerOrgList = async (isReportOwnself) => {
    const reportListRiskOwnerOrg = await getRiskOwnerOrgFilterList()
    const formatReportListStatus = _.map(reportListRiskOwnerOrg?.data, (item) => {
      return { ...item, label: item.level_org_name, value: item.level_org_code }
    })
    setRiskOwnerOrgList(formatReportListStatus)
    if (isReportOwnself && !hederId) {
      const updateRiskOwnerOrg =
        formatReportListStatus.find((item) => {
          return item?.is_pool_org_code === org?.is_pool_org_code
        }) || null
      setRiskOwnerOrg(updateRiskOwnerOrg)
      if (updateRiskOwnerOrg) {
        const buList = await getOptionsBusinessProcessApi({
          bu_id_list: updateRiskOwnerOrg?.bu_id_list,
        })
        const formatBUList = _.map(buList?.data, (item) => {
          return {
            ...item,
            label: item?.report_hd_att_val_name,
            value: item?.report_hd_att_val_id,
          }
        })
        setBUList(formatBUList)

        const userList = await getUserFilterList({
          is_pool_org_code: updateRiskOwnerOrg?.is_pool_org_code,
        })
        if (userList?.status === 'success' && userList?.data) {
          const formatUserList = _.map(userList?.data, (item) => {
            return {
              ...item,
              label: item?.employee?.employee_name_th,
              value: item?.user_id,
            }
          })
          setUserList(formatUserList)
        }
      }
    }
  }

  const getStatusList = async () => {
    const reportListStatus = await getReportStatusListApi()
    const formatReportListStatus = _.map(reportListStatus?.data, (item) => {
      return { ...item, label: item.name, value: item.id }
    })
    setReportStatusList(formatReportListStatus)
  }

  const getBUList = async (bu_id) => {
    const buList = await getOptionsBusinessProcessApi({ bu_id })
    const formatBUList = _.map(buList?.data, (item) => {
      return { ...item, label: item?.report_hd_att_val_name, value: item?.report_hd_att_val_id }
    })
    setBUList(formatBUList)
  }

  const getRiskCo = async () => {
    if (org?.is_pool_org_code) {
      let setparam = org?.is_pool_org_code.split(':')
      let param = {}
      if (setparam[1]) {
        if (setparam[0] === 'company') {
          param = { company_id: [org[setparam[0]]?.company_id] }
        } else if (setparam[0] === 'group') {
          param = { group_id: [org[setparam[0]]?.group_id] }
        } else if (setparam[0] === 'business_unit') {
          param = { bu_id: [org[setparam[0]]?.bu_id] }
        } else if (setparam[0] === 'division') {
          param = { division_id: [org[setparam[0]]?.division_id] }
        } else if (setparam[0] === 'department') {
          param = { department_id: [org[setparam[0]]?.department_id] }
        } else if (setparam[0] === 'section') {
          param = { section_id: [org[setparam[0]]?.section_id] }
        }
        const riskCo2 = await getUserListApi({
          ...param,
          role_id: 6,
        })
        if (riskCo2?.status === 'success') {
          if (riskCo2?.data?.items[0]) {
            setRiskCo(riskCo2?.data?.items[0])
          }
        }
        const riskCo1 = await getUserListApi({
          ...param,
          role_id: 3,
        })
        if (riskCo1?.status === 'success') {
          if (riskCo1?.data?.items[0]) {
            setRiskCo(riskCo1?.data?.items[0])
          }
        }
      }
    }
  }

  const getRiskCoList = async () => {
    let list = []
    const riskCo2 = await getUserListApi({
      role_id: 6,
      size:100
    })
    if (riskCo2?.status === 'success') {
      if (riskCo2?.data?.items) {
        const formatRiskCo2List = _.map(riskCo2?.data?.items, (item) => {
          return { ...item, label: item?.employee?.employee_name_th, value: item?.user_id }
        })
        list = [...list, ...formatRiskCo2List]
      }
    }
    const riskCo1 = await getUserListApi({
      role_id: 3,
      size:100
    })
    if (riskCo1?.status === 'success') {
      if (riskCo1?.data?.items) {
        const formatRiskCo1List = _.map(riskCo1?.data?.items, (item) => {
          return { ...item, label: item?.employee?.employee_name_th, value: item?.user_id }
        })
        list = [...list, ...formatRiskCo1List]
      }
    }
    setRiskCoList(list)
  }

  const getRiskChecker = async () => {
    if (org?.is_pool_org_code) {
      let setparam = org?.is_pool_org_code.split(':')
      let param = {}
      if (setparam[1]) {
        if (setparam[0] === 'company') {
          param = { company_id: [org[setparam[0]]?.company_id] }
        } else if (setparam[0] === 'group') {
          param = { group_id: [org[setparam[0]]?.group_id] }
        } else if (setparam[0] === 'business_unit') {
          param = { bu_id: [org[setparam[0]]?.bu_id] }
        } else if (setparam[0] === 'division') {
          param = { division_id: [org[setparam[0]]?.division_id] }
        } else if (setparam[0] === 'department') {
          param = { department_id: [org[setparam[0]]?.department_id] }
        } else if (setparam[0] === 'section') {
          param = { section_id: [org[setparam[0]]?.section_id] }
        }
        const riskChecker = await getUserListApi({
          ...param,
          role_id: 8,
        })
        if (riskChecker?.status === 'success') {
          if (riskChecker?.data?.items[0]) {
            setRiskChecker(riskChecker?.data?.items[0])
          }
        }
      }
    }
  }

  useAsync(async () => {
    _list()
    getStatusList()
  }, [filters])

  useAsync(async () => {
    getRiskCo()
    getRiskChecker()
    getBUList()
    getRiskCoList()
    getReportTypeList()
  }, [])

  useAsync(async () => {
    console.log('-=-=-=', reportStatusId, +reportStatusId === 1)
    if (!reportStatusId || !id) {
      return
    }

    if (+reportStatusId === 1) {
      if (isRiskAnalyst && reportData?.report_type) {
        let params = {}
        if (reportData?.report_type?.is_report_ownself) {
          //ข้ามสายงาน
          params = { ...params, is_pool_org_code: reportData?.risk_owner_org }
        } else {
          params = { ...params, is_pool: true }
        }
        const res = await getUserFilterList(params)
        if (res?.status === 'success' && res?.data) {
          let data = res?.data.map((item) => {
            return { ...item, label: item?.employee?.employee_name_th, value: item?.user_id }
          })
          setAssigneeOptions(data)
          SetCanSelectAssignee(true)
        }
      }
    } else if (+reportStatusId === 2) {
      if (isRiskAnalyst && reportData?.report_type) {
        let params = {}
        if (reportData?.report_type?.is_report_ownself) {
          //ข้ามสายงาน
          params = { ...params, is_pool_org_code: reportData?.risk_owner_org }
        } else {
          params = { ...params, is_pool: true }
        }
        const res = await getUserFilterList({ role_id: 8, ...params })
        if (res?.status === 'success' && res?.data) {
          let data = res?.data.map((item) => {
            return { ...item, label: item?.employee?.employee_name_th, value: item?.user_id }
          })
          setAssigneeOptions(data)
          SetCanSelectAssignee(true)
        }
      }
    } else if ([4, 5, 6].includes(reportStatusId)) {
      setLoading(true)
      if (isRiskAnalyst && reportData?.report_type) {
        const res = await getUserFilterList({ role_id: 4, report_type_id: reportTypeId })
        if (res?.status === 'success' && res?.data) {
          let data = res?.data.map((item) => {
            return { ...item, label: item?.employee?.employee_name_th, value: item?.user_id }
          })
          setAssigneeOptions(data)
          SetCanSelectAssignee(true)
        }
      } else {
        let roleId = reportStatusId === 4 || reportStatusId === 5 ? 4 : reportStatusId === 6 ? 5 : 0
        const res = await getUserFilterList({ role_id: roleId, report_type_id: id })
        if (res?.status === 'success' && res?.data) {
          let data = res?.data.map((item) => {
            return { ...item, label: item?.employee?.employee_name_th, value: item?.user_id }
          })
          setAssigneeOptions(data)
          SetCanSelectAssignee(true)
        }
      }
      setLoading(false)
    } else if (+reportStatusId === 3) {
      setLoading(true)
      console.log('reportStatusId', reportStatusId)
      console.log('reportData?.reporter', reportData?.reporter)
      if (isRiskAnalyst && reportData?.report_type) {
        let params = {}
        if (reportData?.report_type?.is_report_ownself) {
          //ข้ามสายงาน
          params = { ...params, is_pool_org_code: reportData?.risk_owner_org }
        } else {
          params = { ...params, is_pool: true }
        }
        let list = []

        const res1 = await getUserFilterList({
          role_id: 3,
          ...params,
        })
        if (res1?.status === 'success' && res1?.data) {
          let data = res1?.data.map((item) => {
            return { ...item, label: item?.employee?.employee_name_th, value: item?.user_id }
          })
          list = [...list, ...data]
        }
        const res2 = await getUserFilterList({
          role_id: 6,
          ...params,
        })
        if (res2?.status === 'success' && res2?.data) {
          let data = res2?.data.map((item) => {
            return { ...item, label: item?.employee?.employee_name_th, value: item?.user_id }
          })
          list = [...list, ...data]
        }
        setAssigneeOptions(list)
        SetCanSelectAssignee(true)
      } else if (
        isRiskCo &&
        !isReportOwnself &&
        reportData?.reporter?.employee?.org_structure?.is_pool_org_code !==
          reportData?.riskcoordinator?.employee?.org_structure?.is_pool_org_code
      ) {
        let list = []

        const res1 = await getUserFilterList({
          role_id: 3,
        })
        if (res1?.status === 'success' && res1?.data) {
          let data = res1?.data.map((item) => {
            return { ...item, label: item?.employee?.employee_name_th, value: item?.user_id }
          })
          list = [...list, ...data]
        }
        const res2 = await getUserFilterList({
          role_id: 6,
        })
        if (res2?.status === 'success' && res2?.data) {
          let data = res2?.data.map((item) => {
            return { ...item, label: item?.employee?.employee_name_th, value: item?.user_id }
          })
          list = [...list, ...data]
        }
        setAssigneeOptions(list)
        SetCanSelectAssignee(true)
      } else {
        if (reportData?.reporter?.employee?.org_structure?.is_pool_org_code) {
          let setparam = reportData?.reporter?.employee?.org_structure?.is_pool_org_code.split(':')
          let param = {}
          let list = []
          if (setparam[1]) {
            if (setparam[0] === 'company') {
              param = {
                company_id: [
                  reportData?.reporter?.employee?.org_structure[setparam[0]]?.company_id,
                ],
              }
            } else if (setparam[0] === 'group') {
              param = {
                group_id: [reportData?.reporter?.employee?.org_structure[setparam[0]]?.group_id],
              }
            } else if (setparam[0] === 'business_unit') {
              param = { bu_id: [reportData?.reporter?.employee?.org_structure[setparam[0]]?.bu_id] }
            } else if (setparam[0] === 'division') {
              param = {
                division_id: [
                  reportData?.reporter?.employee?.org_structure[setparam[0]]?.division_id,
                ],
              }
            } else if (setparam[0] === 'department') {
              param = {
                department_id: [
                  reportData?.reporter?.employee?.org_structure[setparam[0]]?.department_id,
                ],
              }
            } else if (setparam[0] === 'section') {
              param = {
                section_id: [
                  reportData?.reporter?.employee?.org_structure[setparam[0]]?.section_id,
                ],
              }
            }
            const riskCo1 = await getUserListApi({
              ...param,
              role_id: 3,
            })

            if (riskCo1?.status === 'success') {
              let formatAssigneeOptions = riskCo1?.data?.items.map((item) => {
                return { ...item, label: item?.employee?.employee_name_th, value: item?.user_id }
              })
              list = [...list, ...formatAssigneeOptions]
            }

            const riskCo2 = await getUserListApi({
              ...param,
              role_id: 6,
            })

            if (riskCo2?.status === 'success') {
              let formatAssigneeOptions = riskCo2?.data?.items.map((item) => {
                return { ...item, label: item?.employee?.employee_name_th, value: item?.user_id }
              })
              list = [...list, ...formatAssigneeOptions]
            }

            setAssigneeOptions(list)
            SetCanSelectAssignee(true)
          }
        }
      }
      setLoading(false)
    } else if (+reportStatusId === 8) {
      setLoading(true)
      if (isRiskAnalyst && reportData?.report_type) {
        const res = await getUserFilterList({ role_id: 5, report_type_id: reportTypeId })
        if (res?.status === 'success' && res?.data) {
          let data = res?.data.map((item) => {
            return { ...item, label: item?.employee?.employee_name_th, value: item?.user_id }
          })
          setAssigneeOptions(data)
          SetCanSelectAssignee(true)
        }
      } else {
        let roleId = 5
        const res = await getUserFilterList({ role_id: roleId, report_type_id: id })
        if (res?.status === 'success' && res?.data) {
          let data = res?.data.map((item) => {
            return { ...item, label: item?.employee?.employee_name_th, value: item?.user_id }
          })
          setAssigneeOptions(data)
          SetCanSelectAssignee(true)
        }
        setLoading(false)
      }
    } else {
      setAssigneeOptions([])
    }
  }, [reportStatusId, reportData, id])

  const getReportData = async () => {
    if (hederId) {
      const res = await getMyIncidentApi({ report_header_id: hederId })
      let reportType = reportTypeList.find(
        (list) => +list?.report_type_id === +res?.data?.report_type_id
      )
      let reportStatus = reportStatusList.find(
        (list) => +list?.report_status_id === +res?.data?.report_status_id
      )
      if (res?.data) {
        setReportData(res?.data)
        setReportTypeData(reportType)
        setReportStatusData(reportStatus)
        setReportStatusId(+res?.data?.report_status_id)
        SetCanEdit(
          +reportStatusId !== 4 &&
            +reportStatusId !== 7 &&
            (res?.data?.can_edit ||
              isRiskAnalyst ||
              (+reportStatusId === 3 &&
                res?.data?.assignee !== null &&
                res?.data?.assignee_id === userId))
        )
        SetCanEditButtonGroup(
          res?.data?.can_edit ||
            (+reportStatusId === 3 &&
              res?.data?.assignee !== null &&
              res?.data?.assignee_id === userId)
        )
        if (reportStatusId === 3 && res?.data?.assignee === null) {
          setLoading(true)
          let roleId =
            reportStatusId === 4 || reportStatusId === 5 ? 4 : reportStatusId === 6 ? 5 : 0
          const res = await getUserFilterList({ role_id: roleId, report_type_id: id })
          if (res?.status === 'success' && res?.data) {
            let data = res?.data.map((item) => {
              return { ...item, label: item?.employee?.employee_name_th, value: item?.user_id }
            })
            setAssigneeOptions(data)
            SetCanSelectAssignee(true)
          }
          setLoading(false)
        }
        const riskOwnerOrg = RiskOwnerOrgList.find(
          (item) => item?.level_org_code === res?.data?.risk_owner_org
        )
        if (RiskOwnerOrgList) {
          if (riskOwnerOrg?.bu_id_list) {
            const buList = await getOptionsBusinessProcessApi({
              bu_id_list: riskOwnerOrg?.bu_id_list,
            })
            const formatBUList = _.map(buList?.data, (item) => {
              return {
                ...item,
                label: item?.report_hd_att_val_name,
                value: item?.report_hd_att_val_id,
              }
            })
            setBUList(formatBUList)
          }

          if (riskOwnerOrg?.is_pool_org_code) {
            const userList = await getUserFilterList({
              is_pool_org_code: riskOwnerOrg?.is_pool_org_code,
            })
            if (userList?.status === 'success' && userList?.data) {
              const formatUserList = _.map(userList?.data, (item) => {
                return {
                  ...item,
                  label: item?.employee?.employee_name_th,
                  value: item?.user_id,
                }
              })

              setUserList(formatUserList)
            }
          }
        }
      }
    } else {
      let reportStatus = reportStatusList.find((list) => +list?.report_status_id === 1)
      let reportType = reportTypeList.find((list) => +list?.report_type_id === id)
      setReportTypeData(reportType)
      setReportStatusData(reportStatus)
      SetCanEdit(true)
      SetCanEditButtonGroup(true)
    }
  }

  useAsync(async () => {
    getReportData()
  }, [hederId, reportTypeList, reportStatusList, RiskOwnerOrgList])

  const selectedDataSource = _.filter(currentDataSource, (currentData) => {
    return _.includes(selectedRowKeys, currentData.key)
  })
  const handleChange = (value) => {
    setReportTypeId(value)
  }
  return (
    <Styled className='page page-user'>
      <Page title={t('Incident Report')} showSearch={false}>
        {/* <Form
          layout='horizontal'
          colon={false}
          name='search'
          onFinish={(v) => {
          }}
          onFinishFailed={(values, errorFields, outOfDate)}
        > */}
        <Space size='middle' direction='vertical' style={{ width: '100%' }}>
          <ReportIncidents
            id={id}
            hederId={hederId}
            reportStatusId={reportStatusId}
            reportData={reportData}
            action={action}
            riskCo={riskCo}
            canEdit={canEdit}
            canSelectAssignee={canSelectAssignee}
            isReportOwnself={isReportOwnself}
            riskOwnself={riskOwnself}
            riskOwnerOrg={riskOwnerOrg}
            assigneeOptions={assigneeOptions}
            isCentralReporter={isCentralReporter}
            riskcoList={riskCoList}
            riskCoOrg={riskCoOrg}
            setValidAssignee={(valid) => setValidAssignee(valid)}
            header={
              <>
                {/* <Space size='middle'> */}
                <Row gutter={[3, 8]} justify='space-around' align='middle'>
                  <Col xs={24} sm={24} md={24} lg={7} gutter={0}>
                    <Row gutter={3}>
                      <Col>
                        {/* {console.log('---',form.getFieldValue())} */}
                        <Button
                          type='primary'
                          onClick={() => setAction('save')}
                          htmlType='submit'
                          disabled={
                            isRiskAnalyst
                              ? reportStatusId === 4
                                ? assigneeOptions?.length > 0
                                  ? !validAssignee
                                  : false
                                : reportStatusId === 7
                              : (+reportStatusId === 3 &&
                                isRiskCo &&
                                !isReportOwnself &&
                                reportData?.reporter?.employee?.org_structure?.is_pool_org_code !==
                                  reportData?.riskcoordinator?.employee?.org_structure
                                    ?.is_pool_org_code
                                  ? false
                                  : !reportStatusData?.is_save) ||
                                (assigneeOptions?.length > 0 && reportStatusId !== 6
                                  ? !assigneeOptions?.find((item) => +item?.user_id === userId)
                                      ?.user_id
                                  : !canEditButtonGroup) ||
                                (!riskCo && !reportData?.riskcoordinator_id) ||
                                (assigneeOptions?.length > 0 ? !validAssignee : false)
                          }
                        >
                          {t('Save')}
                        </Button>
                      </Col>
                      <Col>
                        <Button
                          type='primary'
                          onClick={() => setAction('submit')}
                          htmlType='submit'
                          disabled={
                            isRiskAnalyst
                              ? reportStatusId === 4 || reportStatusId === 7 || reportStatusId === 5
                              : (+reportStatusId === 3 &&
                                isRiskCo &&
                                !isReportOwnself &&
                                reportData?.reporter?.employee?.org_structure?.is_pool_org_code !==
                                  reportData?.riskcoordinator?.employee?.org_structure
                                    ?.is_pool_org_code
                                  ? false
                                  : !reportStatusData?.is_submit) ||
                                (assigneeOptions?.length > 0 && reportStatusId !== 6
                                  ? !assigneeOptions?.find((item) => +item?.user_id === userId)
                                      ?.user_id
                                  : !canEditButtonGroup) ||
                                (!riskCo && !reportData?.riskcoordinator_id) ||
                                (assigneeOptions?.length > 0 ? !validAssignee : false) ||
                                !canEditButtonGroup ||
                                !hederId
                          }
                        >
                          {t('Submit')}
                        </Button>
                      </Col>
                      {reportStatusId !== 7 && reportStatusId !== 1 ? (
                        <Col>
                          <Button
                            type='primary'
                            onClick={() => setAction('reject')}
                            htmlType='submit'
                            disabled={
                              isRiskAnalyst
                                ? reportStatusId === 4 || reportStatusId === 5
                                : (+reportStatusId === 3 &&
                                  isRiskCo &&
                                  !isReportOwnself &&
                                  reportData?.reporter?.employee?.org_structure
                                    ?.is_pool_org_code !==
                                    reportData?.riskcoordinator?.employee?.org_structure
                                      ?.is_pool_org_code
                                    ? false
                                    : !reportStatusData?.is_reject) ||
                                  !canEditButtonGroup ||
                                  !hederId
                            }
                          >
                            {t('Reject')}
                          </Button>
                        </Col>
                      ) : null}
                      {reportStatusId === 7 ? (
                        <Col>
                          <Button
                            type='primary'
                            onClick={() => setAction('re-open')}
                            htmlType='submit'
                          >
                            {t('Re-open')}
                          </Button>
                        </Col>
                      ) : null}
                      <Col>
                        <Button type='primary' danger onClick={() => history.goBack()}>
                          {t('Cancel')}
                        </Button>
                      </Col>
                    </Row>
                  </Col>
                  <Col xs={24} sm={24} md={24} lg={17}>
                    <Row gutter={[3, 0]} justify='end'>
                      <Col xs={24} sm={24} md={24} lg={10}>
                        <Form.Item name='assignee' label='Assignee'>
                          {assigneeOptions.length > 0 ? (
                            <Select
                              options={assigneeOptions}
                              style={{ width: '100%', color: 'black' }}
                              disabled={isRiskAnalyst ? false : reportStatusId === 6}
                            />
                          ) : (
                            <Input disabled style={{ color: 'black' }} />
                          )}
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={24} lg={12}>
                        <Form.Item name='reportcode_cd' label='Report Code'>
                          <Input disabled style={{ color: 'black' }} />
                        </Form.Item>
                      </Col>
                      {reportStatusId === 5 || reportStatusId === 6 ? (
                        <Col xs={24} sm={24} md={24} lg={10}>
                          <Form.Item name='status' label='Status'>
                            <Select
                              options={[
                                { label: 'Investigating', value: 5 },
                                { label: 'Investigated', value: 6 },
                              ]}
                              style={{ width: '100%', color: 'black' }}
                            />
                          </Form.Item>
                        </Col>
                      ) : (
                        <Col xs={24} sm={24} md={24} lg={10}>
                          <Form.Item name='report_status' label='Status'>
                            <Input disabled style={{ color: 'black' }} />
                          </Form.Item>
                        </Col>
                      )}
                      <Col xs={24} sm={24} md={24} lg={12}>
                        <Form.Item name='investigate_code' label='Investigate Code'>
                          <Input disabled style={{ color: 'black' }} />
                        </Form.Item>
                      </Col>
                    </Row>
                  </Col>
                </Row>
                {/* </Space> */}
                <Row
                  gutter={[3, 5]}
                  justify='space-around'
                  style={{ backgroundColor: '#76ad3c85', borderRadius: 25 }}
                >
                  <Col span={23}>
                    {showHeader ? (
                      <Row gutter={4}>
                        <Col xs={24} sm={24} md={24} lg={20}>
                          <h4>Reporter</h4>
                        </Col>
                        <Col xs={24} sm={24} md={24} lg={4}>
                          <Typography.Link
                            underline
                            style={{ color: '#000000d9' }}
                            onClick={() => {
                              history.push(
                                `/report/event-tracking/${reportData?.reportcode_cd || ''}`
                              )
                            }}
                          >
                            Event Tracking <ScheduleOutlined />
                          </Typography.Link>
                        </Col>

                        <Col xs={24} sm={24} md={24} lg={7}>
                          <Form.Item
                            name='reporter'
                            // labelCol={{ span: 5 }}
                            style={{ color: 'black' }}
                            label='Reporter'
                          >
                            <Input disabled style={{ color: 'black' }} />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={24} lg={11}>
                          <Form.Item
                            name='reporter_profile'
                            // labelCol={{ span: 5 }}
                            label='Report Org'
                          >
                            <Input disabled style={{ color: 'black' }} />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={24} lg={6}>
                          <Form.Item
                            name='reporter_date'
                            // labelCol={{ span: 7 }}
                            label='Report Date'
                          >
                            <DatePicker
                              format={'DD/MM/YYYY'}
                              disabled
                              style={{ color: 'black', width: '100%' }}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={24} lg={7}>
                          <Form.Item
                            name='risk_co'
                            // labelCol={{ span: 4 }}
                            label='Risk Co'
                          >
                            {isCentralReporter ? (
                              <Select
                                options={riskCoList}
                                style={{ width: '100%' }}
                                onChange={(a, b) => {
                                  setRiskCoOrg(
                                    b?.employee?.org_structure
                                      ? b?.employee?.org_structure?.section?.section_name !== 'N/A'
                                        ? b?.employee?.org_structure?.section?.section_name
                                        : b?.employee?.org_structure?.department
                                            ?.department_name !== 'N/A'
                                        ? b?.employee?.org_structure?.department?.department_name
                                        : b?.employee?.org_structure?.division?.division_name !==
                                          'N/A'
                                        ? b?.employee?.org_structure?.division?.division_name
                                        : b?.employee?.org_structure?.business_unit?.bu_name !==
                                          'N/A'
                                        ? b?.employee?.org_structure?.business_unit?.bu_name
                                        : b?.employee?.org_structure?.group?.group_name !== 'N/A'
                                        ? b?.employee?.org_structure?.group?.group_name
                                        : b?.employee?.org_structure?.company?.company_name || ''
                                      : ''
                                  )
                                  setRiskCo(b ? b : null)
                                }}
                              />
                            ) : (
                              <Input disabled style={{ color: 'black' }} />
                            )}
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={24} lg={11}>
                          <Form.Item
                            name='risk_co_profile'
                            // labelCol={{ span: 5 }}
                            label='Risk Co Org'
                          >
                            <Input disabled style={{ color: 'black' }} />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={24} md={24} lg={6}>
                          <Form.Item
                            name='validate_date'
                            // labelCol={{ span: 8 }}
                            label='Validate Date'
                          >
                            <DatePicker
                              format={'DD/MM/YYYY'}
                              disabled
                              style={{ color: 'black', width: '100%' }}
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                    ) : null}
                  </Col>
                  {/* <Divider style={{ borderColor: '#585956' }} /> */}
                  <Col span={23}>
                    <Row gutter={12}>
                      <Col span={24}>
                        <h4>Incident Header</h4>
                      </Col>
                      <Col xs={24} sm={24} md={24} lg={12}>
                        <Form.Item
                          name='risk_owner_org'
                          // labelCol={{ span: 4 }}
                          label='สายงานเจ้าของความเสียหาย'
                          rules={[{ required: true }]}
                        >
                          <Select
                            showSearch
                            filterOption={(input, option) =>
                              (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                            }
                            options={RiskOwnerOrgList}
                            disabled={!canEdit || isReportOwnself}
                            style={{ color: 'black' }}
                            onChange={async (v, item) => {
                              const buList = await getOptionsBusinessProcessApi({
                                bu_id_list: item?.bu_id_list,
                              })
                              const formatBUList = _.map(buList?.data, (item) => {
                                return {
                                  ...item,
                                  label: item?.report_hd_att_val_name,
                                  value: item?.report_hd_att_val_id,
                                }
                              })
                              setBUList(formatBUList)

                              const userList = await getUserFilterList({
                                is_pool_org_code: item?.is_pool_org_code,
                              })
                              if (userList?.status === 'success' && userList?.data) {
                                const formatUserList = _.map(userList?.data, (item) => {
                                  return {
                                    ...item,
                                    label: item?.employee?.employee_name_th,
                                    value: item?.user_id,
                                  }
                                })

                                setUserList(formatUserList)
                              }
                            }}
                          />
                        </Form.Item>
                      </Col>
                      {!isConfidential && reportStatusId >= 5 ? (
                        <Col xs={24} sm={24} md={24} lg={12}>
                          <Form.Item name='risk_owner_user_id' label='Risk Owner User'>
                            <Select
                              options={UserList}
                              disabled={!canEdit}
                              style={{ color: 'black' }}
                              mode='multiple'
                            />
                          </Form.Item>
                        </Col>
                      ) : null}
                      {/* <Col span={22}>
                        <Form.Item
                          name='risk_owner_company_id'
                          // labelCol={{ span: 2 }}
                          // label='Risk Owner'
                          label='สายงานเจ้าของความเสียหาย'
                          rules={[{ required: true }]}
                        >
                          <SearchOrganization
                            onChange={(v) => {
                              const reporterFilters = convertOrganizationalStructureToFilters(v)
                              if (reporterFilters?.bu_id && reporterFilters?.bu_id[0]) {
                                getBUList(reporterFilters?.bu_id[0])
                              }
                              return null
                            }}
                            disabled={!canEdit || isReportOwnself}
                            style={{ color: 'black' }}
                          />
                        </Form.Item>
                      </Col> */}
                    </Row>
                    <Row gutter={12}>
                      <Col xs={24} sm={24} md={24} lg={12}>
                        <Form.Item
                          name='incident_topic'
                          // labelCol={{ span: 2 }}
                          // label='Topic'
                          label='ชื่อเรื่องความเสียหาย'
                          rules={[{ required: true }]}
                        >
                          <Input disabled={!canEdit} style={{ color: 'black' }} />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={24} md={24} lg={12}>
                        <Form.Item
                          name='section'
                          // labelCol={{ span: 4 }}
                          label='Bussiness Process'
                          rules={[{ required: true }]}
                        >
                          <Select
                            showSearch
                            filterOption={(input, option) =>
                              (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                            }
                            options={BUList}
                            disabled={!canEdit}
                            style={{ color: 'black' }}
                          />
                        </Form.Item>
                      </Col>

                      {reportData?.reject_description ? (
                        <Col xs={24} sm={24} md={24} lg={18}>
                          <Form.Item
                            name='reject_description'
                            // labelCol={{ span: 2 }}
                            label='เหตุผลของการ Reject'
                          >
                            <InputAntd.TextArea disabled={true} style={{ color: 'black' }} />
                          </Form.Item>
                        </Col>
                      ) : null}
                    </Row>
                  </Col>
                </Row>
                <Row justify='end'>
                  <Col>
                    <Button
                      onClick={() => setShowHeader(!showHeader)}
                      icon={showHeader ? <UpOutlined /> : <DownOutlined />}
                      type='link'
                    >
                      {showHeader ? 'Hide Reporter' : 'Show Reporter'}
                    </Button>
                  </Col>
                </Row>
              </>
            }
          />
          {/* </Card> */}
        </Space>
        {/* </Form> */}
      </Page>
    </Styled>
  )
}
